import React from 'react'
import 'jquery.easing'
import { useLocation,Link } from "react-router-dom";
import $ from "jquery";

const FooterUI = (props) => { return ( <div> 
     <footer id="footer" className={props.footerClass ? props.footerClass : ""}>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6">
                &copy; Copyright{" "}
                <strong>
                  <span>RBI റീട്ടെയിൽ ഡയറക്ട്. </span>
                </strong>
                എല്ലാ അവകാശങ്ങളും{" "}
                <a
                  href="https://www.rbi.org.in/"
                  title="Link will open in new Tab"
                  target="_blank"
                >
                  റിസർവ് ബാങ്ക് ഓഫ് ഇന്ത്യയിൽ നിക്ഷിപ്തം{" "}
                  <i
                    className="ri-external-link-line"
                    style={{ verticalAlign: "-3px" }}
                  ></i>
                </a>
              </div>
              <div className="col-md-6 footer-links">
               <Link to='/PrivacyPolicy'>സ്വകാര്യതാ നയം</Link>
                <Link to="/Disclaimer">നിരാകരണം</Link>
                <Link to="/Contact">ബന്ധപ്പെടുക</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="amg-floating-contacts">
        <div className="amg-floating-contact-wrap">
            <div className="amg-floating-icon" title="Contact Us">
                <i className="ri-customer-service-2-line"></i>
            </div>
            <div className="amg-floating-link">
                <div className="row">
                    <div className="col-md-12">
                        <div>
                            <h6>RBI റീട്ടെയിൽ ഡയറക്‌ട് പിന്തുണ</h6>
                            <p><i class="ri-phone-line"></i> <i class="ri-arrow-right-up-line" style={{marginLeft: '-4px'}}></i><a href="tel:1800 267 7955" title="Out-Bound Number">1800 267 7955</a></p>
                            <p><i class="ri-phone-line"></i> <i class="ri-arrow-left-down-line"  style={{marginLeft: '-4px'}}></i><a href="tel:+91-22-61546335" title="In-Bound Number">+91-22-61546335</a></p>
                            <p><i className="ri-mail-line"></i> <a href="mailto:support@rbiretaildirect.org.in">support@rbiretaildirect.org.in</a></p>
                            <p><i className="ri-time-line"></i> <a style={{color:'#000'}}>10am - 6pm (Mon - Sat)</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>)};export default FooterUI 
